import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Profil() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      setUser(userData);
    } catch (err) {
      console.error(err);
      navigate('/login');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const handleDeleteAccount = async () => {
    try {
      // TODO: Backend endpoint pour supprimer le compte
      localStorage.clear();
      alert('✅ Compte supprimé avec succès');
      navigate('/login');
    } catch (err) {
      console.error(err);
      alert('Erreur lors de la suppression du compte');
    }
  };

  if (!user) {
    return <div className="dashboard"><p>Chargement...</p></div>;
  }

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>👤 Mon Profil</h1>
      </header>

      <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '16px',
        maxWidth: '600px',
        margin: '20px auto',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, color: '#667eea' }}>Informations du compte</h2>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>
            Nom
          </label>
          <p style={{ 
            padding: '10px', 
            background: '#f8f9fa', 
            borderRadius: '8px',
            margin: 0 
          }}>
            {user.name || 'Non défini'}
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>
            Email
          </label>
          <p style={{ 
            padding: '10px', 
            background: '#f8f9fa', 
            borderRadius: '8px',
            margin: 0 
          }}>
            {user.email}
          </p>
        </div>

        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '10px',
          marginTop: '30px' 
        }}>
          <button 
            onClick={handleLogout}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            🚪 Se déconnecter
          </button>

          <button 
            onClick={() => setShowDeleteConfirm(true)}
            className="btn"
            style={{ 
              width: '100%',
              background: '#dc3545',
              color: 'white'
            }}
          >
            🗑️ Supprimer mon compte
          </button>
        </div>
      </div>

      {showDeleteConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }} onClick={() => setShowDeleteConfirm(false)}>
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '16px',
            maxWidth: '400px',
            textAlign: 'center'
          }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: '#dc3545' }}>⚠️ Attention</h3>
            <p>Êtes-vous sûr de vouloir supprimer votre compte ?</p>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>
              Cette action est irréversible. Toutes vos données seront perdues.
            </p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button 
                onClick={() => setShowDeleteConfirm(false)}
                className="btn btn-secondary"
                style={{ flex: 1 }}
              >
                Annuler
              </button>
              <button 
                onClick={handleDeleteAccount}
                className="btn"
                style={{ 
                  flex: 1,
                  background: '#dc3545',
                  color: 'white'
                }}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="dashboard-nav">
        <button onClick={() => navigate('/')} className="nav-btn">
          ← Retour au Dashboard
        </button>
      </div>
    </div>
  );
}

export default Profil;